import { render } from "./NcrmPrivacyEvidenceDoiStatus.vue?vue&type=template&id=6faa4550&scoped=true"
import script from "./NcrmPrivacyEvidenceDoiStatus.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyEvidenceDoiStatus.vue?vue&type=script&lang=js"

import "./NcrmPrivacyEvidenceDoiStatus.vue?vue&type=style&index=0&id=6faa4550&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faa4550"]])

export default __exports__